import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { SharedProperties } from "./share.service";

export class Naturaleses {
  private apiurl = `${this.SharedProperties.baseUrlService()}/MOE/services/naturaleses/`;
  private naturaleses: any[] = [];

  constructor(
    private SharedProperties: SharedProperties,
    private $q: ng.IQService,
    private $http: ng.IHttpService
  ) { }

  getNaturaleses(): any[] {
    this.naturaleses = [
      { id: 1, name: 'Públic' },
      { id: 2, name: 'Privat concertat' },
      { id: 3, name: 'Privat' }
    ];
    return this.naturaleses;
  }

  getNaturalesesPreinscripcio(): any[] {
    this.naturaleses = [
      { id: 1, name: 'Públic' },
      { id: 2, name: 'Privat concertat' }
    ];
    return this.naturaleses;
  }
}

angularJsApp.service(AppServicesEnum.NATURALESES_SERVICE, Naturaleses);
